import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Spinner } from 'react-bootstrap';
import { SelectedSaleAnswer } from './types/SalesTypes';
import { FormSubmitRow, UnsavedChangesNotice } from '../../components/UnsavedChangesNotice/UnsavedChangesNotice';
import { SelectAnswersModal } from './components/SelectAnswersModal';
import { SelectedAnswersTable } from './components/SelectedAnswersTable';

interface SalesFormProps {
  promotionId: number;
  selectedAnswers: SelectedSaleAnswer[];
  onSelectedAnswersChange: (answers: SelectedSaleAnswer[]) => void;
  disabled?: boolean;
  saving?: boolean;
  dirty?: boolean;
  onSave: () => void;
}

export function SalesForm(props: SalesFormProps) {
  const {
    promotionId,
    selectedAnswers,
    onSelectedAnswersChange,
    disabled,
    saving,
    dirty,
    onSave,
  } = props;

  const [modalOpen, setModalOpen] = useState(false);

  const handleDiscountChange = (key: string, discountPercent: number) => {
    onSelectedAnswersChange(
      selectedAnswers.map((row) => (
        row.key === key ? { ...row, discountPercent } : row
      )),
    );
  };

  const handleSetAllDiscounts = (discountPercent: number) => {
    onSelectedAnswersChange(
      selectedAnswers.map((row) => ({ ...row, discountPercent })),
    );
  };

  return (
    <>
      <SelectAnswersModal
        show={modalOpen}
        promotionId={promotionId}
        initialSelection={selectedAnswers}
        onHide={() => setModalOpen(false)}
        onConfirm={onSelectedAnswersChange}
      />

      <div className="mb-3">
        <Button
          type="button"
          variant="outline-primary"
          onClick={() => setModalOpen(true)}
          disabled={disabled}
        >
          Select Answers
        </Button>
      </div>

      <SelectedAnswersTable
        selectedAnswers={selectedAnswers}
        disabled={disabled}
        onDiscountChange={handleDiscountChange}
        onSetAllDiscounts={handleSetAllDiscounts}
      />

      <div className="mt-4">
        <FormSubmitRow>
          <Button
            type="button"
            variant="primary"
            onClick={onSave}
            disabled={disabled || saving || !dirty}
          >
            {saving ? <Spinner animation="border" size="sm" /> : 'Save'}
          </Button>
          <UnsavedChangesNotice show={Boolean(dirty)} />
        </FormSubmitRow>
      </div>
    </>
  );
}
